export default "__VITE_ASSET__Co0U9ZCu__"